export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    //---> BEGIN: Script for Accommodation details page
    //---> Carousel
    $('#lvr-gallery-carousel .owl-carousel').owlCarousel({
      margin: 20,
      loop: true,
      responsiveClass: true,
      items: 2,
      autoWidth: true,
      startPosition: 0,
    });

    const galleryModalEl = '#galleryModal';
    $(galleryModalEl).on('show.bs.modal', function () {
      setTimeout(() => {
        if ($('.modal-backdrop') && $('.modal-backdrop').length > 0) {
          $('.modal-backdrop').addClass('lvr-modal-backdrop');
        }
      }, 100);
    });

    const showGalleryModal = () => {
      $(galleryModalEl).modal('show');
    };

    const hideGalleryModal = () => {
      $(galleryModalEl).modal('hide');
    };

    const handleHideGalleryDetails = el => {
      // Showing gallery grid
      $('.lvr-gallery-grid').removeClass('d-none');

      // Hiding gallery details
      $('.lvr-gallery-detail').addClass('d-none');

      el.attr('data-is-details', 'false');
    };

    // Hide modal
    $(`${galleryModalEl} .btn-close-modal`).click(evt => {
      const $this = $(evt.currentTarget);
      const isDetails = $this.attr('data-is-details') === 'true' ? true : false;
      if (isDetails) {
        handleHideGalleryDetails($this);
      } else {
        hideGalleryModal();
        handleHideGalleryDetails($this);
      }
    });

    /**
     * Updating gallery information (media source, description)
     * @param {*} mediaSrc
     * @param {*} mediaDescription
     * @param {*} currentPage
     * @param {*} totalPage
     */
    const updateGalleryItemInfo = ({
      mediaSrc,
      mediaDescription,
      currentPage,
      totalPage,
    }) => {
      $('.lvr-gallery-slider-item img').attr('src', mediaSrc);
      $('.lvr-gallery-slider-item .lvr-gallery-description').html(
        mediaDescription
      );
      $('.lvr-gallery-detail .lvr-page-number').text(
        currentPage // parseInt(currentIdx) + 1
      );
      $('.lvr-gallery-detail .lvr-total-page').text(totalPage);
    };

    const handleLoadActiveGallery = ({currentMediaEl, currentIdx}) => {
      if (currentMediaEl && currentMediaEl.length > 0) {
        const mediaSrc = currentMediaEl.attr('data-media-src');
        const mediaDescription = currentMediaEl.attr('data-media-description');
        const currentPage = parseInt(currentIdx) + 1;
        const totalPage = galleryItemEl.length;
        updateGalleryItemInfo({
          mediaSrc,
          mediaDescription,
          currentPage,
          totalPage,
        });
        $('.slider-actions').attr('data-current-index', currentIdx);
      }
    };

    // Handle click on gallery item -> show gallery details
    const galleryItemEl = $('.lvr-media-item-wrap .lvr-item-overlay');

    if (galleryItemEl && galleryItemEl.length > 0) {
      galleryItemEl.click(evt => {
        const $this = $(evt.currentTarget);
        const modalCloseBtn = $this
          .closest('.modal-content')
          .find('.lvr-btn-modal-back');
        const currentIdx = $this.attr('data-item-index');

        // Add mode details for back button
        if (modalCloseBtn && modalCloseBtn.length) {
          modalCloseBtn.attr('data-is-details', 'true');
        }

        // Hiding gallery grid
        $('.lvr-gallery-grid').addClass('d-none');

        // Showing gallery details
        $('.lvr-gallery-detail').removeClass('d-none');

        // Get element by current index
        const currentMediaEl = $this.parent('.lvr-media-item-wrap');
        handleLoadActiveGallery({currentMediaEl, currentIdx});
      });
    }

    // Handle click prev/next
    $('.slider-actions .slider-btn').click(evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const $this = $(evt.currentTarget);
      const isNext = $this.attr('data-type') === 'next' ? true : false;
      const currentIdx = $this
        .closest('.slider-actions')
        .attr('data-current-index');

      if (isNext) {
        const nextIdx = parseInt(currentIdx) + 1;
        const nextItemEl = $('.lvr-media-item-wrap').get(nextIdx);
        if (nextIdx <= $('.lvr-media-item-wrap').length) {
          handleLoadActiveGallery({
            currentMediaEl: $(nextItemEl),
            currentIdx: nextIdx,
          });
        }
      } else {
        const prevIdx = parseInt(currentIdx) - 1;
        const prevItemEl = $('.lvr-media-item-wrap').get(prevIdx);
        if (prevIdx >= 0) {
          handleLoadActiveGallery({
            currentMediaEl: $(prevItemEl),
            currentIdx: prevIdx,
          });
        }
      }
    });

    // Handle click on button show 15 photo
    const handleClickOnButtonShowPhoto = () => {
      $('#lvr-gallery-carousel .lvr-banner-btn').click(evt => {
        evt.preventDefault();
        evt.stopPropagation();
        showGalleryModal();
      });
    };
    handleClickOnButtonShowPhoto();
    //---> END: Script for Accommodation details page
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleSkiArea.js